import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import DropDown from 'components/forms/new/formikFormFields/DropDown';

const TPMCallingProfilesField = (props) => {
    const {
        field,
        form,
        options,
        darkMode,
        disableStackHeight,
        value,
        onChange,
        error,
        showError,
    } = props;
    const [isHovered, setIsHovered] = useState(false);

    // Support both Formik and non-Formik usage
    const rawValue = typeof value !== 'undefined' ? value : field?.value;

    const selectedIds = Array.isArray(rawValue)
        ? rawValue
              .map((val) => val?.id ?? val?.value)
              .filter((id) => id !== undefined && id !== null)
        : [];

    const handleSelectChange = (ids) => {
        const selectedOptions = (ids || [])
            .map((id) => options?.find((opt) => opt.id === id))
            .filter(Boolean);

        if (typeof onChange === 'function') {
            onChange(selectedOptions);
        } else if (form?.setFieldValue) {
            form.setFieldValue(field.name, selectedOptions);
        }
    };

    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={
                    disableStackHeight
                        ? { width: '775px' }
                        : {
                              ...stackStyling(true),
                              height: 'auto',
                              minHeight: '75px',
                          }
                }
                width="100%">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Calling Profiles{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select one or more calling profiles for this service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <DropDown
                        data={options}
                        shownValue="name"
                        isMulti
                        multiValue={selectedIds}
                        width="100%"
                        darkMode={darkMode}
                        placeholder="- Select Calling Profiles -"
                        handleSelectChange={handleSelectChange}
                        name={field?.name || 'callingProfiles'}
                        walkthroughId={
                            walkthroughIds.serviceProfiles
                                ?.ufCallingProfilesSelect
                        }
                    />
                    {showError && (
                        <Text
                            color="red.500"
                            fontSize="xs"
                            mt={1}
                            textAlign="right">
                            {error}
                        </Text>
                    )}
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select one or more calling profiles for this service."
                        ariaLabel="tpm-calling-profiles-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default TPMCallingProfilesField;
